/**
 * Persist routine-suggestion dismissals per project chat.
 *
 * Once the clinician closes (or accepts) the create/update card in a chat,
 * we never show it again for that project — even after reload.
 */

const STORAGE_KEY = 'heidi.routine-suggestion.dismissed-projects';
const MAX_TRACKED_PROJECTS = 200;

const readIds = (): string[] => {
  if (typeof window === 'undefined') return [];
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((value): value is string => typeof value === 'string');
  } catch {
    return [];
  }
};

const writeIds = (ids: string[]): void => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(ids.slice(-MAX_TRACKED_PROJECTS))
    );
  } catch {
    // Best-effort only — private mode / quota should not break chat.
  }
};

export const isRoutineSuggestionDismissedForProject = (projectId: string): boolean => {
  if (!projectId) return false;
  return readIds().includes(projectId);
};

export const dismissRoutineSuggestionForProject = (projectId: string): void => {
  if (!projectId) return;
  const existing = readIds().filter((id) => id !== projectId);
  existing.push(projectId);
  writeIds(existing);
};

/** Test helper — clears the dismiss store. */
export const clearRoutineSuggestionDismissals = (): void => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
};
